import { render } from "./ParcelList.vue?vue&type=template&id=1e0dfcb5&scoped=true"
import script from "./ParcelList.vue?vue&type=script&lang=js"
export * from "./ParcelList.vue?vue&type=script&lang=js"

import "./ParcelList.vue?vue&type=style&index=0&id=1e0dfcb5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1e0dfcb5"

export default script